module.exports = __webpack_public_path__ + "static/media/arrow-blue.ece0e910.svg";